module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M15.354 17.644c.358.468.936.476 1.292.008L21.82 11c.358-.472.164-1-.43-1H18V1c0-.55-.448-1-1-1h-2c-.552 0-1 .45-1 1v9h-3.39c-.594 0-.788.53-.43 1l5.174 6.644zM30 14h-7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v6h-7a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1H4v-6h5a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H2c-1.106 0-2 .894-2 2v14c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V16c0-1.106-.894-2-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/download-inbox-1.js
// module id = 1122
// module chunks = 14